import {NgModule} from '@angular/core';
import {CommonModule} from '@angular/common';
import {TeamSelectorComponent} from './team-selector.component';
import {TooltipPanelModule} from '../tooltip-panel/tooltip-panel.module';
import {TeamNavLinkModule} from '../../smart/main-layout/team-nav-link/team-nav-link.module';
import {DirectivesModule} from '../../../common/directives/directives.module';
import {ImgCacheBusterDirective} from '../../../directives/img-cache-buster';
import {TeamNavLinkGroupFeatureModule} from '../../smart/main-layout/team-nav-link-group-feature/team-nav-link-group-feature.module';
import {TeamItemGroupFeatureComponent} from './components/team-item-group-feature/team-item-group-feature.component';
import {TeamItemComponent} from './components/team-item/team-item.component';
import {TooltipPanelGroupFeatureModule} from '../tooltip-panel-group-feature/tooltip-panel-group-feature.module';
import {TooltipPanelWrapperComponent} from '../tooltip-panel-wrapper/tooltip-panel-wrapper.component';

@NgModule({
  declarations: [TeamSelectorComponent],
  imports: [
    CommonModule,
    TooltipPanelModule,
    TeamNavLinkModule,
    DirectivesModule,
    ImgCacheBusterDirective,
    TeamNavLinkGroupFeatureModule,
    TeamItemComponent,
    TeamItemGroupFeatureComponent,
    TooltipPanelGroupFeatureModule,
    TooltipPanelWrapperComponent,
  ],
  exports: [TeamSelectorComponent],
})
export class TeamSelectorModule {}
